import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import { EMPTY_PROPERTY_VALUE } from '../constants/EmptyPropertyValue';
export const getInvoiceStatusDot = value => {
  // Property options: https://tools.hubteam.com/puma/objects/INVOICE/properties/hs_invoice_status/details
  switch (value) {
    case 'paid':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        "data-test-id": "invoice-status-dot-paid",
        use: "success"
      });

    case 'voided':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        "data-test-id": "invoice-status-dot-voided",
        use: "danger"
      });

    case 'open':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        "data-test-id": "invoice-status-dot-open",
        use: "warning"
      });

    case 'draft':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        "data-test-id": "invoice-status-dot-draft",
        use: "default"
      });

    default:
      return undefined;
  }
};

const FormattedInvoiceStatus = ({
  property,
  value
}) => {
  if (value === null || value === undefined || value === '') {
    return /*#__PURE__*/_jsx("span", {
      children: EMPTY_PROPERTY_VALUE
    });
  }

  return /*#__PURE__*/_jsxs("span", {
    children: [getInvoiceStatusDot(value), getDisplayedValue(property, value)]
  });
};

export default FormattedInvoiceStatus;